import o from "./CdrSkeleton.vue2.mjs";
import s from "./styles/CdrSkeleton.module.scss.mjs";
import t from "../../_virtual/_plugin-vue_export-helper.mjs";
const e = {
  $style: s
}, f = /* @__PURE__ */ t(o, [["__cssModules", e]]);
export {
  f as default
};
